import { EDevice } from '@constants';
import { useEffect, useRef } from 'react';

import { sdk } from '@/services';
import { useProfile } from '@/store';
import { getIsMobileWebView } from '@/utils';

const SessionLogService = sdk.getService('SessionLogService');

export const UserPingHandler = () => {
  const { profile } = useProfile();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const isMobileWebView = getIsMobileWebView();
  const device = isMobileWebView ? EDevice.MOBILE : EDevice.WEB;

  useEffect(() => {
    if (!profile) return;

    const sendPing = async () => {
      try {
        await SessionLogService.ping(device);
      } catch (error) {
        console.error('Error sending ping:', error);
      }
    };

    sendPing();

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      sendPing();
    }, 30000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [profile, device]);

  return null;
};
